// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/finalize_set_dressing_reference.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { SetDressingReference } from "./set_dressing_reference_pb";
import { file_vision_assets_v1_set_dressing_reference } from "./set_dressing_reference_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/finalize_set_dressing_reference.proto.
 */
export const file_vision_assets_v1_finalize_set_dressing_reference: GenFile = /*@__PURE__*/
  fileDesc("CjZ2aXNpb24vYXNzZXRzL3YxL2ZpbmFsaXplX3NldF9kcmVzc2luZ19yZWZlcmVuY2UucHJvdG8SF3Byb3Rvcy52aXNpb24uYXNzZXRzLnYxIsQBCiNGaW5hbGl6ZVNldERyZXNzaW5nUmVmZXJlbmNlUmVxdWVzdBJTCgZwYXJhbXMYASABKAsyQy5wcm90b3MudmlzaW9uLmFzc2V0cy52MS5GaW5hbGl6ZVNldERyZXNzaW5nUmVmZXJlbmNlUmVxdWVzdC5QYXJhbXMSGAoQY2xpZW50X3VwbG9hZF9pZBgCIAEoCRouCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCRIQCghhc3NldF9pZBgCIAEoCSLIAQokRmluYWxpemVTZXREcmVzc2luZ1JlZmVyZW5jZVJlc3BvbnNlElQKBnJlc3VsdBgBIAEoCzJELnByb3Rvcy52aXNpb24uYXNzZXRzLnYxLkZpbmFsaXplU2V0RHJlc3NpbmdSZWZlcmVuY2VSZXNwb25zZS5SZXN1bHQaSgoGUmVzdWx0EkAKCXJlZmVyZW5jZRgBIAEoCzItLnByb3Rvcy52aXNpb24uYXNzZXRzLnYxLlNldERyZXNzaW5nUmVmZXJlbmNlYgZwcm90bzM", [file_vision_assets_v1_set_dressing_reference]);

/**
 * @generated from message protos.vision.assets.v1.FinalizeSetDressingReferenceRequest
 */
export type FinalizeSetDressingReferenceRequest = Message<"protos.vision.assets.v1.FinalizeSetDressingReferenceRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.FinalizeSetDressingReferenceRequest.Params params = 1;
   */
  params?: FinalizeSetDressingReferenceRequest_Params | undefined;

  /**
   * @generated from field: string client_upload_id = 2;
   */
  clientUploadId: string;
};

/**
 * Describes the message protos.vision.assets.v1.FinalizeSetDressingReferenceRequest.
 * Use `create(FinalizeSetDressingReferenceRequestSchema)` to create a new message.
 */
export const FinalizeSetDressingReferenceRequestSchema: GenMessage<FinalizeSetDressingReferenceRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_finalize_set_dressing_reference, 0);

/**
 * @generated from message protos.vision.assets.v1.FinalizeSetDressingReferenceRequest.Params
 */
export type FinalizeSetDressingReferenceRequest_Params = Message<"protos.vision.assets.v1.FinalizeSetDressingReferenceRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string asset_id = 2;
   */
  assetId: string;
};

/**
 * Describes the message protos.vision.assets.v1.FinalizeSetDressingReferenceRequest.Params.
 * Use `create(FinalizeSetDressingReferenceRequest_ParamsSchema)` to create a new message.
 */
export const FinalizeSetDressingReferenceRequest_ParamsSchema: GenMessage<FinalizeSetDressingReferenceRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_finalize_set_dressing_reference, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.FinalizeSetDressingReferenceResponse
 */
export type FinalizeSetDressingReferenceResponse = Message<"protos.vision.assets.v1.FinalizeSetDressingReferenceResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.FinalizeSetDressingReferenceResponse.Result result = 1;
   */
  result?: FinalizeSetDressingReferenceResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.FinalizeSetDressingReferenceResponse.
 * Use `create(FinalizeSetDressingReferenceResponseSchema)` to create a new message.
 */
export const FinalizeSetDressingReferenceResponseSchema: GenMessage<FinalizeSetDressingReferenceResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_finalize_set_dressing_reference, 1);

/**
 * @generated from message protos.vision.assets.v1.FinalizeSetDressingReferenceResponse.Result
 */
export type FinalizeSetDressingReferenceResponse_Result = Message<"protos.vision.assets.v1.FinalizeSetDressingReferenceResponse.Result"> & {
  /**
   * @generated from field: protos.vision.assets.v1.SetDressingReference reference = 1;
   */
  reference?: SetDressingReference | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.FinalizeSetDressingReferenceResponse.Result.
 * Use `create(FinalizeSetDressingReferenceResponse_ResultSchema)` to create a new message.
 */
export const FinalizeSetDressingReferenceResponse_ResultSchema: GenMessage<FinalizeSetDressingReferenceResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_finalize_set_dressing_reference, 1, 0);

